import styled from 'styled-components';

const Title = styled.span`
  flex-grow: 1;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: ${({ isDesktop }) => (isDesktop ? '15px' : '13px')};
  letter-spacing: 1px;
  line-height: 21px;
`;

export default Title;
